import { getWindow } from "./auth-service-tools662.js";

function checkIsBrowser() {
  var _window = getWindow();

  return Boolean(typeof _window !== "undefined" && _window.document && _window.document.createElement);
}

var canUseDOM = checkIsBrowser();
export { canUseDOM };